// removed by extract-text-webpack-plugin
module.exports = {"controlsInner":"extra-pages---controlsInner---2VAVU","buttonContainer":"extra-pages---buttonContainer---1riS4","navigation":"extra-pages---navigation---isdLd","addExtraPage":"extra-pages---addExtraPage---g6U1o","remainingPages":"extra-pages---remainingPages---1Zle3","extraPage":"extra-pages---extraPage---UQypO","dropDownHeader":"extra-pages---dropDownHeader---2_-1B","dropDownHeaderSelected":"extra-pages---dropDownHeaderSelected---3D2HX","tabGroup":"extra-pages---tabGroup---2xdu_","iconPicker":"extra-pages---iconPicker---375ZL","tabGroupLi":"extra-pages---tabGroupLi---1w1Sz","categoryLi":"extra-pages---categoryLi---1bNfi","categoryTabItem":"extra-pages---categoryTabItem---1js3x","tabItem":"extra-pages---tabItem---5OKbq","categoryItem":"extra-pages---categoryItem---1smG_","categoryTabItemSelected":"extra-pages---categoryTabItemSelected---29ZwK","padLeft":"extra-pages---padLeft---22eTu","closeSelector":"extra-pages---closeSelector---2HTxM"};;
    if (module.hot) {
      var injectCss = function injectCss(prev, href) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = href;
        link.onload = function() {
          document.head.removeChild(prev);
        };
        document.head.appendChild(link);
      };
      module.hot.dispose(function() {
        window.__webpack_reload_css__ = true;
      });
      if (window.__webpack_reload_css__) {
        module.hot.__webpack_reload_css__ = false;
        console.log("[HMR] Reloading stylesheets...");
        var prefix = document.location.protocol + '//' + document.location.host;
        document
          .querySelectorAll("link[href][rel=stylesheet]")
          .forEach(function(link) {
            if (!link.href.match(prefix)) return;
            injectCss(link, link.href.split("?")[0] + "?unix=1789047462865");
          });
      }
    }
  